import type { Slug } from '@bridebook/toolbox/src/types';
import getLastBookedSupplier from '@bridebook/web/lib/weddings/utils/get-last-booked-supplier';

/* Get last item in shortlisted sorted by createdAt and that is also of a slug venue and is booked */
const getLastBookedVenue = <T extends { booked: boolean; type: Slug; updatedAt?: number }>(
  list: Record<string, T>,
): T | undefined => getLastBookedSupplier(list, 'venue');

export default getLastBookedVenue;
